var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 13.5 9.7",
    style: {
      enableBackground: "new 0 0 13.5 9.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:inherit;}\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Laag_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_986",
    className: "st0",
    d: "M13.3,4.5L9,0.2c-0.2-0.2-0.5-0.2-0.8,0L7.9,0.5C7.7,0.7,7.7,1,7.9,1.2c0,0,0,0,0,0l3,3H0.3 C0.2,4.2,0,4.4,0,4.6l0,0v0.6c0,0.2,0.2,0.3,0.3,0.3c0,0,0,0,0,0h10.5l-3,3c-0.2,0.2-0.2,0.5,0,0.8l0.3,0.3c0.2,0.2,0.5,0.2,0.8,0 l4.3-4.3C13.5,5,13.5,4.7,13.3,4.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.60a64ea581e66b69edc032720a2951d6.svg";
export { ForwardRef as ReactComponent };